import React from "react";
import { LogHelper } from 'com-gyf-webcore-loghelper';
/**
 * Funcion que devuelve un componente que renderiza un footer para la distribucion de limites - tarjetas
 * @param {any} props
 */
const TableFooter = (props) => {
    let totalLimit = 0;
    let novedades = props.data.novedadesTarjetas || [];
    let limitErrorCard = false;
    //Busco las tarjetas para la cuenta seleccionada y las recorro
    props.data.tarjetas.filter((ta1) => ta1.CuentaTarjetaId == props.cuentaSeleccionada.Id && ta1.TieneBaja != "1").forEach((tar2) => {
        let novedad = novedades.find((n) => n.TarjetaCreditoId == tar2.Id);
        //Si existe una novedad, sumo su valor
        if (novedad) {
            totalLimit += parseFloat(novedad.ValorNovedad);
        } else {
            //Si no existe, tomo el de la tarjeta
            totalLimit += parseFloat(tar2.Limite || tar2.PorcentajeLimiteCompra);
        }
    });

    totalLimit = isNaN(totalLimit) ? 0 : totalLimit;
    if (totalLimit < 0) {
        limitErrorCard = true;
    }

    return (
        <div className="row">
            <div className="col-md-1">
            </div>
            <div className="col-md-3">
                <label className="label-secondary">Total:</label>
            </div>
            <div className="col-md-6">
                {limitErrorCard == true
                    ? <label className="label-secondary color-red">{totalLimit}%</label>
                    : <label className="label-secondary">{totalLimit}%</label>}
            </div>
            <div className="col-md-2">
            </div>
        </div>
    );
};

export default TableFooter